import { render, staticRenderFns } from "./CompensationIntermediateThrowEvent.vue?vue&type=template&id=56d6bbc6&scoped=true&"
import script from "./CompensationIntermediateThrowEvent.vue?vue&type=script&lang=js&"
export * from "./CompensationIntermediateThrowEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6bbc6",
  null
  
)

export default component.exports